// Retur Pembelian / Retur Penjualan as native ESC/P for the Epson LX-310.
// The two HTML versions are identical except the title, the "No. Faktur"
// fallback field and the warehouse label, so a single factory builds both.
// Page layout (boxed table, page numbers, footer) comes from halfFormEscp.js.

import {
  buildHalfFormDoc,
  STANDARD_COLUMNS,
  STANDARD_TOTALS,
} from "./halfFormEscp";

const fmtDate = (data) => {
  const raw = data.transaction_date;
  if (!raw) return "-";
  const d = new Date(raw);
  return isNaN(d.getTime()) ? "-" : d.toLocaleDateString("id-ID");
};

// Per-document differences between Retur Pembelian and Retur Penjualan.
const VARIANTS = {
  pembelian: {
    title: "RETUR PEMBELIAN",
    fakturNumber: (data) => data.document_number || data.spk_number || data.id,
    warehouseLabel: "Gudang Tujuan",
  },
  penjualan: {
    title: "RETUR PENJUALAN",
    fakturNumber: (data) => data.document_number || data.sj_number || data.id,
    warehouseLabel: "Gudang Asal",
  },
};

const buildReturEscp = (variant) => {
  const config = {
    title: variant.title,
    infoLines: (data) => [
      ["Tanggal", fmtDate(data), "No. SJ", data.sj_number || "-"],
      [
        "No. Faktur",
        variant.fakturNumber(data),
        variant.warehouseLabel,
        data.warehouse_name || "-",
      ],
    ],
    columns: STANDARD_COLUMNS,
    groupHeader: { label: "JUMLAH", span: 2 },
    totalSpan: 5,
    totals: STANDARD_TOTALS,
    notes: (data) => data.notes || "-",
    signatureLabel: "Yang membuat,",
    signatureName: (data) => data.user_username || "-",
    maxItemsPerPage: 7,
  };
  return (data, itemsPerPage = 6) =>
    buildHalfFormDoc(config, data, itemsPerPage);
};

export const buildReturPembelianEscp = buildReturEscp(VARIANTS.pembelian);
export const buildReturPenjualanEscp = buildReturEscp(VARIANTS.penjualan);
